export const addBrackets = (string)=>{
    if (string.startsWith("(") && string.endsWith(")")) {
        return string;
    }
    return `(${string})`;
};
